import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Культурный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Культурный туризм охватывает собой посещение исторических, культурных или географических
                        достопримечательностей.</p>
                    <p className="sub">Экскурсионно-познавательные туры</p>
                    <p>Данные туры являются самым популярным и массовым видом туризма. Основная цель таких путешествий —
                        ознакомление с туристскими достопримечательностями (памятниками истории, архитектуры, искусства;
                        природными и этническими особенностями; современной жизнью народа и т. п.).</p>
                    <div className="two-col-cell">
                        <ul>
                            <li><a href='https://brestobl.com/turizm/marsh/8.html'>Тадеуш Костюшко - сын земли
                                белорусской</a></li>
                            <li><a href='https://brestobl.com/turizm/marsh/4.html'>Россыпь талантов полесских</a></li>
                            <li><a href='https://brestobl.com/turizm/marsh/6.html'>По историческим и памятным местам
                                Западной Белоруссии</a></li>
                            <li><a href='https://brestobl.com/turizm/marsh/7.html'>Полесские узоры</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}